import React from 'react'
import {
  renderTextInput,
  FormikRadioGroup,
} from 'components/forms/SharedInputs'
import { Field, FieldArray } from 'formik'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import {
  storeCollection,
  genderOptions,
} from 'components/forms/SharedCollections'
import Checkbox from '@material-ui/core/Checkbox'

const SponsoredSignUp = ({
  values,
  setFieldValue,
  errors,
  touched,
  registrationError,
  Captcha,
  isInProgress,
}) => {
  const isFieldValid = field => {
    return errors[field] && touched[field] ? false : true
  }

  return (
    <div className="signup__form new-form-fields">
      <ul className="form__elements" style={{ padding: '4px' }}>
        <li className="form__element">
          <Field
            name="email"
            type="text"
            label="Email"
            placeholder={'Email'}
            component={renderTextInput}
            error={errors.email}
            touched={touched.email && true}
          />
        </li>
        <li className="form__element">
          <Field
            name="password"
            type="password"
            label="Password"
            placeholder={'Password'}
            component={renderTextInput}
            error={errors.password}
            touched={touched.password && true}
          />
        </li>

        <li className="form__element">
          <Field
            name="birthDate"
            type="date"
            label="Birthday"
            component={renderTextInput}
            shrink={true}
            error={errors.birthDate}
            touched={touched.birthDate && true}
          />
        </li>
        <li
          className={`form__element${isFieldValid('gender') ? '' : ' invalid'}`}
        >
          <div className="gender">
            <span className="field-title">
              Gender{' '}
              <span className="invalid-text">*This field is required.</span>
            </span>
            <Field
              name="gender"
              type="radio"
              label="Gender"
              placeholder={'Gender'}
              options={genderOptions}
              component={FormikRadioGroup}
              error={errors.gender}
              touched={touched.gender && true ? 'true' : ''}
            />
          </div>
        </li>
        <li
          className={`form__element${
            isFieldValid('storeIds') ? '' : ' invalid'
          }`}
        >
          <span className="field-title">
            Where do you shop for essentials?{' '}
            {errors.storeIds && (
              <span className="invalid-text">*{errors.storeIds}</span>
            )}
          </span>
          <ul className="checkbox-container">
            <FieldArray
              name="storeIds"
              render={arrayHelpers => (
                <>
                  {storeCollection.map((store, i) => {
                    return (
                      <li key={i}>
                        {' '}
                        <FormControlLabel
                          value={store.label}
                          control={
                            <Checkbox
                              name="storeIds"
                              type="checkbox"
                              id={'store-' + store.value}
                              value={store.value}
                              // checked={false}
                              onChange={e => {
                                if (e.target.checked) {
                                  arrayHelpers.push(store.value)
                                } else {
                                  const idx = values.storeIds.indexOf(
                                    store.value,
                                  )
                                  arrayHelpers.remove(idx)
                                }
                              }}
                            />
                          }
                          label={store.label}
                          labelPlacement="end"
                        />
                      </li>
                    )
                  })}
                </>
              )}
            />
          </ul>
        </li>
        <li
          className={`form__element${
            isFieldValid('captchaResponseToken') ? '' : ' invalid'
          }`}
        >
          <Captcha onChange={e => setFieldValue('captchaResponseToken', e)} />
          {errors.captchaResponseToken && (
            <span className="invalid-text">*{errors.captchaResponseToken}</span>
          )}
          <span className="invalid-text">*This field is required.</span>
          <small className="form__ack">
            By clicking "Sign Up" I acknowledge that I have read and agree to be
            bound by Breaktime Media MWH LLC's{' '}
            <a href={'/terms'} target="_blank">
              Terms of Use
            </a>{' '}
            and{' '}
            <a href={'/privacy'} target="_blank">
              Privacy Policy
            </a>
            .
          </small>
        </li>
        <li className="form__submit-wrapper">
          <input
            className="btn"
            type="submit"
            value="Sign Up"
            disabled={isInProgress}
          />
        </li>

        {registrationError && (
          <p
            className="error"
            dangerouslySetInnerHTML={{ __html: registrationError }}
          ></p>
        )}
      </ul>
    </div>
  )
}
export default SponsoredSignUp
